import { getAuthEntities } from "@/api/information.js";
import { getHotelReviewsNote, getHotelReviewsNoteCount, getRestaurantReviewsNote } from "@/api/note.js";

export default {
  namespaced: true,
  state: {
    hotelList: [],
    currentHotelId: null,
    isShowSider: true,
    IsItAutomaticallyFolded: false,
    // 独立于 isShowSider（桌面端"展开/收起成图标条"）——这个控制的是 <1024px 时侧边栏
    // 作为浮层抽屉的开关，从不持久化，每次刷新/进入页面都应该是关闭的。
    isMobileSidebarOpen: false,
    // <1024px（和 Navbar.vue 的手机顶栏同一阈值）。放进 Vuex 而不是 Sidebar/index.vue 自己的
    // data，是因为 RouterMenu.vue 也需要知道这个状态才能在手机抽屉打开时正确渲染展开态菜单
    // （它自己直接读 isShowSider，不经过 Sidebar/index.vue 的 props），单一数据源避免两处各
    // 自挂一个 resize 监听器。
    isMobileNav: false,
    needsAttentionCount: 0,
    hasRestaurant: true,
    /** 当前是否为酒店模块（与侧栏 Hotel / Restaurant 切换一致） */
    isHotel: true,
  },
  mutations: {
    SET_IsItAutomaticallyFolded (state, newState) {
      state.IsItAutomaticallyFolded = newState;
    },
    SET_SHOW_SIDE (state, payload) {
      state.isShowSider = payload;
    },
    SET_MOBILE_SIDEBAR_OPEN (state, payload) {
      state.isMobileSidebarOpen = payload;
    },
    SET_MOBILE_NAV (state, payload) {
      state.isMobileNav = payload;
    },
    SET_HOTEL_LIST(state, list) {
      state.hotelList = Array.isArray(list) ? list : [];
    },
    SET_NEEDS_ATTENTION_COUNT(state, count) {
      state.needsAttentionCount = count;
    },
    SET_HAS_RESTAURANT(state, val) {
      state.hasRestaurant = val;
    },
    SET_IS_HOTEL(state, isHotel) {
      state.isHotel = !!isHotel;
    },
    SET_CURRENT_HOTEL(state, id) {
      const isValidHotel = state.hotelList.some(
        (hotel) => hotel.hotelId === id
      );
      if (isValidHotel) {
        state.currentHotelId = id;
      } else {
        console.warn("无效的酒店ID:", id);
        state.currentHotelId =
          state.hotelList.length > 0 ? state.hotelList[0].hotelId : null;
      }
    },
  },
  getters: {
    currentHotel: (state) => {
      return state.hotelList.find(
        (hotel) => hotel.hotelId === state.currentHotelId
      );
    },
  },
  actions: {
    async fetchNeedsAttentionCount({ commit, state, rootState }, { startDate, endDate } = {}) {
      const hotelId = state.currentHotelId;
      const restaurantId = rootState.restaurant.selectedRestaurantId;
      if (!state.isHotel) {
        if (!restaurantId) return;
      } else if (!hotelId) {
        return;
      }
      try {
        if (!state.isHotel) {
          const [all, closed] = await Promise.all([
            getRestaurantReviewsNote({ restaurantId, page: 0, size: 1, startDate, endDate }),
            getRestaurantReviewsNote({ restaurantId, page: 0, size: 1, status: "Closed", startDate, endDate }),
          ]);
          const count = (all.totalElements || 0) - (closed.totalElements || 0);
          commit('SET_NEEDS_ATTENTION_COUNT', Math.max(0, count));
        } else {
          const { totalCount, closeCount } = await getHotelReviewsNoteCount({ hotelId, startDate, endDate });
          const count = (totalCount || 0) - (closeCount || 0);
          commit('SET_NEEDS_ATTENTION_COUNT', Math.max(0, count));
        }
      } catch {
        commit('SET_NEEDS_ATTENTION_COUNT', 0);
      }
    },
  },
};
